import { AriaRole } from "react";

import Box from "ds/components/Box";
import Tag from "ds/components/Tag";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import TextHighlight from "ds/components/TextHighlight";

import { isComplexObjectType } from "./utils";
import { formatDefaultValue } from "../OptionalInputs/utils";

type InputNameProps = {
  name: string;
  type: string;
  description: string;
  role?: AriaRole;
};

const InputName = ({ name, type, description, role }: InputNameProps) => {
  const isComplex = isComplexObjectType(type);

  return (
    <Box role={role}>
      <Box direction="column" gap="small" fullWidth>
        <Box gap="medium" align="center" fullWidth>
          <TextEllipsis tooltip={name}>
            {(props) => (
              <Typography {...props} tag="span" variant="p-body2">
                {name}
              </Typography>
            )}
          </TextEllipsis>

          {!isComplex && <Tag tag={type} />}
        </Box>
        {isComplex && (
          <Box>
            <TextHighlight tag="pre">{formatDefaultValue(type)}</TextHighlight>
          </Box>
        )}

        {description && (
          <Typography tag="p" variant="p-body3" color="secondary">
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default InputName;
